/**
 * Prototype UI — replace with Medplum hooks later.
 *
 * Batch runs only include claims that were attempted for submission (submitted or failed).
 * Claims not ready for billing are excluded from the batch entirely.
 */

export type BatchRunStatus = 'completed' | 'partial' | 'failed' | 'running';

export interface BatchClaimOutcome {
  claimId: string;
  clientName: string;
  outcome: 'submitted' | 'failed';
  errorSummary?: string;
}

export interface BatchRunRow {
  id: string;
  startedAt: string;
  status: BatchRunStatus;
  submittedCount: number;
  failedCount: number;
  claimOutcomes: BatchClaimOutcome[];
}

export const MOCK_BATCH_RUNS: BatchRunRow[] = [];

export function findBatchRunById(id: string | undefined): BatchRunRow | undefined {
  if (!id) return undefined;
  return MOCK_BATCH_RUNS.find((r) => r.id === id);
}
